import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ allowedRoles }) => {
  const { authenticated, role } = useAuth(); // Mudado de roles para role

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verifica se a role do usuário está na lista de permissões
  // Se role for "ASSINANTE" e allowedRoles for ["ASSINANTE"], ele passa
  const hasAccess = allowedRoles.includes(role);

  if (!hasAccess) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;